import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchGoogleExtractSpreadsheet, fetchGoogleFolderItems, fetchGoogleRootFolders } from "../services/googleService";
import useConnectionStore from "../store/useConnectors";


/**
 * Root folders
 */
export const useGoogleRootFolders = (mimeType = "") =>{
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    return useQuery({
        queryKey: ["gdrive", "folders", "root", connectionId],
        queryFn: () => fetchGoogleRootFolders(connectionId, mimeType),
        enabled: !!connectionId,
        staleTime: 5 * 60 * 1000, // 5 min
    });
}

/**
 * Folder items
 */
export const useGoogleFolderItems = (folderId, mimeType = "") => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    return useQuery({
        queryKey: ["gdrive", "folder", connectionId, folderId],
        queryFn: () => fetchGoogleFolderItems(connectionId, folderId, mimeType),
        enabled: !!folderId && !!connectionId, // 🔥 only run when folderId exists
        staleTime: 5 * 60 * 1000,
    });
}

// EXTRACT FORMS
export const useExrtactionGoogleSpreadsheet = () => {
    const connectionId = useConnectionStore((s) => s.activeConnectionId);
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: (payload) => {
        return fetchGoogleExtractSpreadsheet(connectionId, payload);
      },
      onSuccess: () => {
        // refresh extracttion list
        queryClient.invalidateQueries({ queryKey: ['extraction'] });
      }
    });
  };
